(function($) {
    $.fn.dataTable.ext.errMode = function (settings, tn, msg) {
        if (settings && settings.jqXHR && settings.jqXHR.status == 401) {
            // Handling for 401 specifically
            window.location.reload();
            return;
        }
        // Handling for all other errors, this implements the DataTables default 
        // behavior of throwing an alert
        alert(msg)
    };
})(jQuery)